import { render, staticRenderFns } from "./SimpleNode.vue?vue&type=template&id=04e90fc2&scoped=true&"
import script from "./SimpleNode.vue?vue&type=script&lang=js&"
export * from "./SimpleNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e90fc2",
  null
  
)

export default component.exports